import { KubitProvider } from '@kubit-ui-web/react-components';
import type { ReactNode } from 'react';

import { SocketProvider } from '@/socket/SocketProvider';

/**
 * Single mount point for every app-wide provider, so screens never have to
 * know the ordering. `KubitProvider` sits outermost because it carries the
 * error boundary: a socket failure should render inside the themed shell
 * rather than blanking the page.
 */
export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <KubitProvider>
      <SocketProvider>{children}</SocketProvider>
    </KubitProvider>
  );
}
